import React from 'react';
import { useAdministrationOverlay } from '@piwikpro/router-crate';
import AddToGroup from './Profile/UserGroups/AddToGroup';

interface Props {
  onMembershipsChanged: () => void
}

const UserDetailsOverlay: React.FC<Props> = ({ onMembershipsChanged }) => {
  const overlay = useAdministrationOverlay();

  if (overlay === '/m/add-to-group') {
    return <AddToGroup onMembershipsChanged={onMembershipsChanged} />;
  }

  return null;
};

export default UserDetailsOverlay;
